import { FileModel } from "../models/shared/file.model";
import { AccuserModel } from "./conferencing";

export class DefaultAppealJudgementViewModel {
    cId: number = 0
    secId: number = 0
    suitId: number = 0
    reqId: number = 0
    filingAS: number = 0
    suitTypeId: number = 0
    filingASDOCS: number = 1
    filingGroup: number = 0
    suitBlackNo: number = 0
    suitBlackYear: string = ''
    suitRedNo: string = ''
    suitRedYear: string = ''
    userSelected: number[] = []
    filesPermission: AppealFilePermissionModel = new AppealFilePermissionModel
}

export class AppealFilePermissionModel {
    pageCount: number = 0
    files: FileModel[] = []
}

export class DefaultAppealJudgementModel {
    reQID: number = null!
    filingAS: number = 0
    filingAsDocs: number = 1
    filingGroup: number = 0
    administrativeCourt: number = null!
    blackNumberCase: number = null!
    redNumberCase: number = null!
    suitBlackCode: number = null!
    suitBlackYear: string = null!
    suitRedNo: string = null!
    suitRedYear: string = null!
    suitID: number = 0
    userSelected: number[] = []
    filesPermission: FileModel[] = []
    pageCountPermissionPDf: number = 0
    suitTypeId: number = 0
}

export class AccuserAppealModel {
    filingAs: AccuserAppealDetailModel[] = []
}

export class AccuserAppealDetailModel {
    id: number = 0
    seq: number = 0
    groupId: number = 0
    checked: boolean = false
}

export class AppealSearchModel {
    administrativeCourt: number = null!;
    blackNumberCase: number = null!;
    suitBlackCode: number = null!;
    suitBlackYear: string = null!;
    redNumberCase: number = null!;
    suitRedCode: number = null!;
    suitRedYear: string = null!;
    suitTypeId: number = 0
    fdtId: number = null!
    suitId:number = null!
    refCode: string = ''
    isRefCode: boolean = false
    caseId: number = 0
}

export class AccuserAppealListModel {
    filingAs: AccuserAppealDetailModel[] = []
}

export class AccuserAppealListDetailModel {
    id: number = 0
    seq: number = 0
    groupId: number = 0
    checked: boolean = false
}

export class AccuserAppealListViewModel {
    plaintiffs: AccuserAppealDetailViewModel[] = []
    defandants: AccuserAppealDetailViewModel[] = []
    intercessors: AccuserAppealDetailViewModel[] = []
    items: AccuserAppealDetailViewModel[] = []
}
export class AccuserAppealDetailViewModel {
    accId: number = 0
    accName: string = ''
    accSurName: string = ''
    groupId: number = 0
    seq: number = 0
    checked: boolean = false
    accShowName: string = ''
}

export class AppealModel {
    status2: any
    administrativeCourt: number = null!;
    blackNumberCase: number = null!;
    suitBlackCode: number = null!;
    suitBlackYear: string = null!;
    suitRedNo: number = null!;
    suitRedYear: number = null!;
    status: number = 0
    subStatus: any
    accusers: AccuserAppealListViewModel = new AccuserAppealListViewModel
    // plaintiffAndAttorneyNumbers: AccuseritemModel[] = []
    // defendantAndAttorneyNumbers: AccuseritemModel[] = []
    suitID: number = 0;
    fdTID: number = 0;
    reQID: number = 0;

    remark: string = ''
    userSelecteds: AppealUserSeclectedViewModel[] = []

    fdIdFileSuitPdf: number = 0
    fdIdFileSuitWord: number = 0
    fdIdFileEtc: number = 0
    fdIdFilePermission: number = 0
    courtType:number = 0
}

export class AppealUserSeclectedViewModel {
    accId: number = 0
    groupId: number = 0
}

export class PositionInSuitViewModel {
    filingAs: number = 0
    positionSuitName: string = ''
    showType: number = 0
    isInvalid: boolean = false
    groupIds: number[] = []
    selectedGroupId: number = 0
}

export class SuitCoopViewModel {
    respFunc: boolean = false
    type: number = 0
}

export class AppealCaseSuitDetailModel {
    ref: string = ''
    ref2: string = ''
    titleRef: string = ''
    titleRef2: string = ''
    colorCode: string = ''
    colorCode2: string = ''
    suitAccuser: string = ''
    suitAccused: string = ''
    courtName: string = ''
    curerentUserName: string = ''
    isCoop: boolean = false
    typeCoop: number = 0
}

export class AppealDraftRequestViewModel {
    fdtId: number = 0
    fdtName: string = ''
    filingAs: number = 0
    filingAsDocs: number = 0
    filingAsName: string = ''
    filingAsName2: string = ''
    filingGroupName: string = ''
    formName: string = ''
    dtlClob: string = ''
    closeJudgDate: Date = null!
    bReadDate: Date = null!
    filesPermission: DraftRequestFileViewModel = new DraftRequestFileViewModel
    fileSuitPdf: DraftRequestFileViewModel = new DraftRequestFileViewModel
    fileSuitWord: DraftRequestFileViewModel = new DraftRequestFileViewModel
    filesEtc: DraftRequestFileViewModel = new DraftRequestFileViewModel
    payment: DraftRequestPaymentViewModel = new DraftRequestPaymentViewModel

}

export class DraftRequestFileViewModel {
    pageFdName: string = ''
    pageCount: number = 0
    files: FileModel[] = []
}

export class DraftRequestPaymentViewModel {
    suitPayType: number = 0
    accusers: PaymentAccuserDetailViewModel[] = []
}

export class PaymentAccuserDetailViewModel {
    accId: number = 0
    accName: string = ''
    accSurName: string = ''
    accCapital: number = 0
    accFees: number = 0
    accSeq: number = 0
    submitted:boolean = false
}